import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../../features/Product/redux/ProductList.slice";
import "../../../assets/css/Allfilter.css";

const FilterAllProduct = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState({});
  const {
    filters = {},
    selectedFilters = {},
  } = useSelector((state) => state.product);

  // Multiple checkbox filter
  const handleCheckbox = (filterName, value) => {
    const selected = selectedFilters[filterName] || [];
    const values = selected.includes(value)
      ? selected.filter((x) => x !== value)
      : [...selected, value];
    dispatch(
      setFilter({
        key: filterName,
        value: values,
      })
    );
  };

  // Price radio filter
  const handleRadio = (filterName, item) => {
    const value = item.slug || item.value;
    dispatch(
      setFilter({
        key: filterName,
        value: value,
      })
    );
  };



  return (
    <div className="Accordions-filter">
      <Accordion
        alwaysOpen
        defaultActiveKey={
          Object.keys(filters).map((_, i) => String(i))
        }
      >
        {
          Object.entries(filters).map(([filterName, items], index) => (
            <Accordion.Item
              key={filterName}
              eventKey={String(index)}
            >
              <Accordion.Header>
                {filterName
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, c => c.toUpperCase())}
              </Accordion.Header>
              <Accordion.Body>
                {
                  !filterName.toLowerCase().includes("price") &&
                  items?.length > 8 &&
                  <span className="input-icon-serch">
                    <span className="filter-search-icon">
                      <i className="bi bi-search"></i>
                    </span>
                    <input
                      type="search"
                      className="form-control inputfiletrserach"
                      placeholder={`Search ${filterName}...`}
                      value={searchText[filterName] || ""}
                      onChange={(e) =>
                        setSearchText(prev => ({
                          ...prev,
                          [filterName]: e.target.value
                        }))
                      }
                    />
                  </span>
                }
                <div className="filter-Scroll">
                  {
                    items
                      ?.filter(item => {
                        const search =
                          (searchText[filterName] || "")
                            .toLowerCase();
                        if (!search) return true;
                        return item.text
                          ?.toLowerCase()
                          .includes(search);
                      })


                      .map((item, idx) => {
                        const value =
                          item.slug || item.value;
                        const isPrice =
                          filterName.toLowerCase().includes("price") ||
                          filterName.toLowerCase().includes("range");
                        const checked =
                          isPrice
                            ?
                            selectedFilters[filterName] === value
                            :
                            Array.isArray(selectedFilters[filterName])
                            &&
                            selectedFilters[filterName].includes(value);

                        return (
                          <div className="checkbox-container" key={value || idx} >
                            <label className="checkbox-label">
                              {
                                isPrice
                                  ?
                                  (
                                    // PRICE RADIO BUTTON
                                    <input
                                      type="radio"
                                      name={filterName}
                                      style={{ marginRight: "5px" }}
                                      checked={checked}
                                      onChange={() =>
                                        handleRadio(filterName, item)
                                      }
                                    />
                                  )
                                  :
                                  (

                                    // OTHER CHECKBOX
                                    <input
                                      type="checkbox"
                                      className="checkbox-input"
                                      checked={checked}
                                      onChange={() =>
                                        handleCheckbox(filterName, value)
                                      }
                                    />
                                  )
                              }

                              {item.text}
                            </label>
                          </div>
                        );
                      })

                  }
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))
        }
      </Accordion>
    </div>
  );
};
export default FilterAllProduct;